/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronicline.com | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
(function () {
  function initPromoBannerSection(section) {
    if (typeof ScrollReveal === 'undefined' || window.innerWidth <= 801) return;

    var $body = $(section).find('.promo-banner__body');
    if (!$body.length) return;

    ScrollReveal().reveal($body[0], {
      origin: 'bottom',
      distance: '20px',
      duration: 700,
      delay: 0,
      easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
      opacity: 0,
      scale: 1,
      once: true
    });
  }

  function initAllPromoBannerSections() {
    document.querySelectorAll('.promo-banner').forEach(function (section) {
      if (section.dataset.pbInit) return;
      section.dataset.pbInit = 'true';
      initPromoBannerSection(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllPromoBannerSections);
  } else {
    initAllPromoBannerSections();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.classList && event.target.classList.contains('promo-banner')
      ? event.target
      : event.target.querySelector && event.target.querySelector('.promo-banner');
    if (section) {
      delete section.dataset.pbInit;
      initPromoBannerSection(section);
      section.dataset.pbInit = 'true';
    }
  });
})();